module.exports = __webpack_public_path__ + "img/img-promo-superior.9990aef0.svg";